import { AnalyticsService } from './AnalyticsService.generated';

const analytics = new AnalyticsService();
export { analytics };
